import find from 'lodash/find'
import WcsImages from '@/scripts/libs/wcs/images'
import { Image } from '@/scripts/libs/wcs/types/manifest'
import wcs from '@/scripts/libs/wcs'

const { assetMiddleLayerImagesHost } = wcs.getStoreConfig()

class TryLens {
  getLensSwatch = (selectedTryLens: string) => {
    return (
      'https://images.ray-ban.com/extra/image/RayBan/DL/lens-swatch_' + selectedTryLens + '.png'
    )
  }

  getMaskImage = (selectedTryLens: string) => {
    return (
      'https://images.ray-ban.com/extra/image/RayBan/DL/DraggableLenses_' +
      selectedTryLens +
      '_Mask.jpg?impolicy=RB_Draggable'
    )
  }

  getMaskImageForPDP = async (partNumber: string) => {
    const manifest = await WcsImages.getManifest(partNumber)
    const image = find(
      manifest.payload.images,
      (image: Image) => image.usage === 'DRAGGABLE' && image.order === 2
    )
    const url = image?.path
    return `${assetMiddleLayerImagesHost}${url}`
  }

  getBaseImage = (selectedTryLens: string) => {
    return (
      'https://images.ray-ban.com/extra/image/RayBan/DL/DraggableLenses_' +
      selectedTryLens +
      '_Base.jpg?impolicy=RB_Draggable'
    )
  }

  getBaseImageForPDP = async (partNumber: string) => {
    const manifest = await WcsImages.getManifest(partNumber)
    const image = find(
      manifest.payload.images,
      (image: Image) => image.usage === 'DRAGGABLE' && image.order === 1
    )
    const url = image?.path
    return `${assetMiddleLayerImagesHost}${url}`
  }

  getDefaultDescriptionKey = (colorCategoryIdentifier: string): string => {
    if (colorCategoryIdentifier.includes('Classic')) {
      return 'classic'
    } else if (colorCategoryIdentifier.includes('Mirror')) {
      return 'mirror'
    } else if (colorCategoryIdentifier.includes('Premium')) {
      return 'premium'
    } else if (colorCategoryIdentifier.includes('Gradient')) {
      return 'gradient'
    } else if (colorCategoryIdentifier.includes('Evolve')) {
      return 'evolve'
    } else if (colorCategoryIdentifier.includes('Chromance')) {
      return 'chromance'
    } else if (colorCategoryIdentifier.includes('Transitions®')) {
      return 'transitions'
    } else {
      return 'classic'
    }
  }
}

export default new TryLens()
